module.exports = __webpack_public_path__ + "img/131.6.fe894d2e.png";